import { Link, Navigate } from '@tanstack/react-router';
import { useAuth } from '../lib/auth';
import { RegisterForm } from '../components/auth/RegisterForm';
import { Card } from '../components/ui/Card';
import { useTranslation } from 'react-i18next';

export function RegisterPage() {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">{t('common:loading')}</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary-600 mb-2">{t('common:app_name')}</h1>
          <h2 className="text-2xl font-semibold text-gray-900">{t('auth:register_title')}</h2>
          <p className="mt-2 text-gray-600">{t('auth:register_subtitle')}</p>
        </div>
        <Card>
          <RegisterForm />
          <div className="mt-6 text-center text-sm text-gray-600">
            {t('auth:already_have_account')}{' '}
            <Link to="/login" className="text-primary-600 hover:text-primary-700 font-medium">
              {t('auth:login_here')}
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
